import React, { useLayoutEffect, useRef, useState } from "react";
import { IconActiveProps } from "./Items";
import { ItemContainer, ItemLabel, SectionContainer } from "./Sidebar.styled";

interface SidebarItemProps {
	label: string;
	isActive: boolean;
	Icon: React.FC<IconActiveProps>;
	navigateToRoute: () => void;
	isExpanded: boolean;
	onClick?: () => void;
}

const SidebarItem = ({ navigateToRoute, Icon, isActive, label, isExpanded, onClick }: SidebarItemProps) => {
	const containerRef = useRef<HTMLDivElement>(null);

	const [isExpandedInner, setIsExpandedInner] = useState(true);
	const [maxHeight, setMaxHeight] = useState<number>();

	const handleSidebarClick = () => onClick?.();

	useLayoutEffect(() => {
		setMaxHeight(containerRef.current?.scrollHeight);
		setIsExpandedInner(false);
	}, [isExpanded]);

	return (
		<SectionContainer
			onClick={handleSidebarClick}
			id={label}
			style={{ maxHeight: isExpandedInner ? `${maxHeight}px` : "40px" }}
			ref={containerRef}>
			<ItemContainer $isActive={isActive} onClick={navigateToRoute}>
				<Icon isActive={isActive} />
				<ItemLabel $isActive={isActive}>{label}</ItemLabel>
			</ItemContainer>
		</SectionContainer>
	);
};

export default SidebarItem;
